import { InjectionToken } from '@angular/core';
import { EduraMediaBreakpoint } from './custom-breakpoints';

export const EDURA_WINDOW = new InjectionToken<Window>('Window');
export const EDURA_DOCUMENT = new InjectionToken<Document>('Document');
export const EDURA_MEDIA_BREAKPOINTS = new InjectionToken<
  EduraMediaBreakpoint[]
>('Edura Media Breakpoints');
